import React, { useEffect, useRef } from 'react';

const ImageInfoOverlay = ({ title, description, onClose }) => {
  const closeButtonRef = useRef(null);
  const triggerElementRef = useRef(null);

  useEffect(() => {
    triggerElementRef.current = document.activeElement;
    closeButtonRef.current?.focus();

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      triggerElementRef.current?.focus();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-85 w-full h-full text-white p-8 z-50 flex flex-col items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="image-overlay-title"
      onClick={onClose}
    >
      <button
        ref={closeButtonRef}
        className="fixed top-5 right-8 text-2xl text-white bg-white bg-opacity-10 backdrop-blur border-none cursor-pointer z-50 w-10 h-10 rounded-full flex items-center justify-center hover:bg-opacity-20 transition-all duration-300"
        onClick={onClose}
        aria-label="Close"
      >
        ✕
      </button>
      <div className="text-center max-w-2xl" onClick={(e) => e.stopPropagation()}>
        <h2 id="image-overlay-title" className="text-2xl md:text-3xl font-bold mb-4 text-space-blue-200">{title}</h2>
        <p className="text-lg md:text-xl leading-relaxed text-gray-300">{description}</p>
      </div>
    </div>
  );
};

export default ImageInfoOverlay;
